import MyButton from './MyButton';

const MyButtonSecondary = ({
  color = 'primary',
  variant = 'outlined',
  ghost = true,
  ...otherProps
}) => {
  return <MyButton
    {...otherProps}
    color={color}
    variant={variant}
    ghost={ghost}
  />;
};

export default MyButtonSecondary;
